import React from 'react'
import CopyButtonBase from './CopyButtonBase'

export default function CopyButtonInBox({ style, variant = 'subtle', ...props }) {
  return (
    <span style={{ position: 'relative', display: 'block', width: '100%' }}>
      <span style={{ position: 'absolute', top: 2, right: 10, ...(style || {}) }}>
        <CopyButtonBase {...props} variant={variant} />
      </span>
    </span>
  )
}
